module.exports = __webpack_public_path__ + "img/checkbox_dim_24.383527b2.svg";